import type { CesRoute } from '../enums';

export interface CesCriterion {
  stage: string;
  criterion: string;
  risk: string;
}

export interface CesRouteDef {
  name: CesRoute;
  criteria: CesCriterion[];
}

export const CES_ROUTE_DEFS: Record<CesRoute, CesRouteDef> = {
  'Formal Tendering - Contracts': {
    name: 'Formal Tendering - Contracts',
    criteria: [
      {
        stage: '1. Assess compliance at strategy stage of the procurement process',
        criterion: '1.1 Check if the transaction is part of the approved divisional procurement plan (Instruction Note 01 of 2024: 2.1.3)',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess compliance at strategy stage of the procurement process',
        criterion: '1.2 Check if all Cross Functional Teams (CFT) have been formally appointed in writing (32-1034: 8.8: 8.8.1)',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess compliance at strategy stage of the procurement process',
        criterion: '1.3 Inspect signed Conflict Declaration status (DoI & NDA) (32-1034: 4.2.1 & 4.3.3)',
        risk: 'possible non-compliance',
      },
      {
        stage: '1. Assess compliance at strategy stage of the procurement process',
        criterion: '1.4 Assess approved strategy by the relevant Delegated Adjudication Authority (DAA) (32-1034: 8.8.3)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance at enquiry stage of the procurement process',
        criterion: '2.1 Check if the content of an Enquiry is consistet with the approved Strategy (32-1034: 8.8.4)',
        risk: 'potential non-compliance depending on what is in the ITT/RFP',
      },
      {
        stage: '2. Assess compliance at enquiry stage of the procurement process',
        criterion: '2.2 Check if the letter of invitation is signed by the designated Procurement Manager (32-1034: 8.8.4 (a))',
        risk: 'non-conformance',
      },
      {
        stage: '2. Assess compliance at enquiry stage of the procurement process',
        criterion: '2.3 Proof of advertisement to all relevant portals (National Treasury, Eskom Bulletin, and CIDB if is the requirement) (32-1034: 8.8.6)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance at enquiry stage of the procurement process',
        criterion: '2.4 Check management of clarification queries & publication of responses to the relevant platforms (32-1034: 8.8.6 & 8.8.7)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance at enquiry stage of the procurement process',
        criterion: '2.5 If the tender was cancelled, check if the tender cancellation process was followed, including internal approvals, publication of the cancellation and ensuring tender validity (32-1034: 8.8.8 & 8.8.11)',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance at evaluation stage of the procurement process',
        criterion: '3.1 Inspect Signed COI & NDA by all evaluators (32-1034: 8.8.12 (a))',
        risk: 'non-conformance',
      },
      {
        stage: '3. Assess compliance at evaluation stage of the procurement process',
        criterion: '3.2 Inspect signed evaluations sheets (e.g., Commercial, Technical, SHEQ, SDL&I, QS / Financial Analysis etc.) (32-1034: 8.8.12)',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance at evaluation stage of the procurement process',
        criterion: '3.3 Check and ensure alignment of evaluations with the approved strategy & enquiry issued (Costitution Section 217)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Assess compliance at adjudication & negotiations stage of the procurement process',
        criterion: '4.1 Check alignment of the evaluation outcome and the recommendation made to the DAA (Costitution Section 217)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Assess compliance at adjudication & negotiations stage of the procurement process',
        criterion: '4.2 Check approved adjudication reports (evaluation, mandate & feedback) (32-1034: 8.13)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Assess compliance at adjudication & negotiations stage of the procurement process',
        criterion: '4.3 Inspect negotiation pack (Strategy, agenda, signed minutes, DoI etc,) (32-1034: 8.8.12(q))',
        risk: 'non-conformance',
      },
      {
        stage: '4. Assess compliance at adjudication & negotiations stage of the procurement process',
        criterion: '4.4 Check alignment of the negotiation outcome with the recommendation made to the relevant DAA (32-1034: 8.8.12(q))',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.1 Check if the award is in accordace with the provision of the relevent contract(s) including SDL&I targets e.g. NEC, FIDIC, etc. (32-1034: 8.8.14 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.2 Inspect if the award is still within the validity period (internal approval, acceptance of extension from suppliers, publication of the extension) (32-1034: 8.8.11)',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.3 Inspect if NEC contract is Fully signed by all relevant designated parties, initialled and witnessed (32-1034: 8.8.14 (b))',
        risk: 'non-conformance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.4 Compare alignment of the awarded contract with SAP. E.g., Target value, contigency, SDL&I etc. (32-1034: 8.8.14 (d))',
        risk: 'possible non-compliance if not in line with DAA approval',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.5 Inspect Compliance of the statutory documents of the awarded supplier (Tax, BBBEE, CIDB, CSD etc.) (32-1034: 10.2.1 & 8.8.12)',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.6 Check if the contract has foreign component, if so, check if the forward cover was taken in line with the relevant threshold (32-1034: 10.1.10)',
        risk: 'non-conformance - possible FWE (Fruitless & Wasteful Expenditure)',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.7 Check if the contract has foreign content equal or above 5 million US Dollars, if so was the certificate for NIPP obtained from DTI? (Eskom Preferential Procurement Policy: 2.2.6.3)',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance on Award Publication of the tender',
        criterion: '6.1 Inspect proof of publication of successful and unsuccessful tenders on the National Treasury eTender Portal, Eskom Portal and CIDB Portals. (32-1034: 8.8.14 (C))',
        risk: 'possible non-compliance',
      },
      {
        stage: '7. Assess compliance on Documents Management process',
        criterion: '7.1 Inspect if all relevant documents are uploaded on Eskom Electronic Document Management System (EDMS) (32-1034: 8.2.2)',
        risk: 'non-conformance',
      },
      {
        stage: '7. Assess compliance on Documents Management process',
        criterion: '7.2 Check alignment of the physical file and EDMS (32-1034: 8.2.2)',
        risk: 'non-conformance',
      },
    ],
  },
  "Informal Tendering - PO's": {
    name: "Informal Tendering - PO's",
    criteria: [
      {
        stage: '1. Identifying when it is permissible to use the informal tendering mechanism',
        criterion: '1.1 Check if the transaction does not exceed a maximum value of R1m. (32-1034: 8.7.1)',
        risk: 'possible non-compliance',
      },
      {
        stage: '1. Identifying when it is permissible to use the informal tendering mechanism',
        criterion: '1.2 Check if the transaction is executed by the accredited Procurement Practitioner. E.g PIE , Forex Etc. (32-1034: 8.3.1 and 8.7.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '1. Identifying when it is permissible to use the informal tendering mechanism',
        criterion: '1.3 Check if the Hierarchy of Suppliers was followed.(32-1034: Appendix C:C2)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '2.1 Check if the RFQ was issued via the CSD platform/System (Prucurement Instruction Note 03 of 2025)',
        risk: 'Depends on when the transaction took place vs departure',
      },
      {
        stage: '2. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '2.2 Check if the issued RFQ included the scope, specifications and price schedules, as well as any drawings that were applicable (32-1034: Appendix C-C3.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '2.3 Check if the following documents were attached to the RFQ and stipulated as mandatory tender returnables for evaluation: 1 Authorisation Form; 2. Integrity Pact & Integrity Declaration Form, 3. Declaration of Shareholding and Directorship, 4. SBD 4 form (Bidder’s Declaration of Interest) (32-1034: Appendix C-C3.4)',
        risk: 'Depends - which doc is legislative . i.e SBD4',
      },
      {
        stage: '2. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '2.4Check if the functionality and SDL&I requirements were applicable, if so, were they issued with the RFQ pack.(32-1034: Appendix C-C3.8 and C3.10)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '2.5 Check if CSD was used to source suppliers (Minimum of 6 suppliers)(32-1034: Appendix C-C4.',
        risk: 'Depends is "6" an Eskom requirement?',
      },
      {
        stage: '2. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '2.6 If the CSD platform was not available to source suppliers, check if a screenshot was taken as evidence and approval was sought from the Procurement Manager to deviate from using the CSD platform including conducting market analysis to identify possible suppliers. (32-1034: Appendix C-C4)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '2.7 In case there were any queries from invited suppliers: Check how queries were handled and managed in line with the Constitutional principles S217 (Constituion 217 & CSD etendering process)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '2.8 If the RFQ was cancelled, check if the approval was sought from the relevant Procurement Manager (32-1034: Appendix C-C6)',
        risk: 'non-conformance',
      },
      {
        stage: '3. Assess compliance at evaluation level of the procurement process',
        criterion: '3.1 Check signed evaluations sheets (e.g., Commercial, Technical, SHEQ, SDL&I, QS etc.) (32-1034: Appendix C-C7)',
        risk: 'non-conformance',
      },
      {
        stage: '3. Assess compliance at evaluation level of the procurement process',
        criterion: '3.2 Check if the End-user and the Procurement Practitioner have completed a conflict of interest declaration (COI) (32-1034: Appendix C-C7.2)',
        risk: 'non-conformance',
      },
      {
        stage: '3. Assess compliance at evaluation level of the procurement process',
        criterion: '3.3 Check if the recommended supplier was the highest score in terms of the PPPFA, subject to the application of objective criteria if those were specified in the RFQ (32-1034: Appendix C-C7.7 & PPR2022)',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance at evaluation level of the procurement process',
        criterion: '3.4 Check if the Procurement Practitioner did ascertain that the prices are fair, reasonable and market-related before recommending an order / contract (32-1034: Appendix C-C7.8)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4.Assess compliance at adjudication & negotiations level of the procurement process',
        criterion: '4.1 Check if the adjudication reports are approved by relevant DAA in accordance with DOA (evaluation, mandate & feedback) (32-1034: 8.7.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4.Assess compliance at adjudication & negotiations level of the procurement process',
        criterion: '4.2 Check the negotiation process followed (32-1034: Appendix C-C9)',
        risk: 'non-conformance',
      },
      {
        stage: '4.Assess compliance at adjudication & negotiations level of the procurement process',
        criterion: '4.3 Check alignment of the negotiation outcome with the recommendation made to the relevant DAA (32-1034: Appendix C-C8)',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.1 Check if award is in line with the approval from the relevant DAA (minute/report) (32-1034: Appendix C-C8)',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.2 Check if the award is still within the validity period (internal approval, acceptance of extension from suppliers, publication of the extension) (Costitution Section 217)',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.3 Compare alignment of the awarded PO with SAP amount (Good governance)',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance during contracting phase',
        criterion: '5.4 Inspect Tax compliance at PO award and placement (32-1034: Appendix C-C7.10)',
        risk: 'possible non-compliance',
      },
    ],
  },
  'LPO': {
    name: 'LPO',
    criteria: [
      {
        stage: '1 Check the Validity /Training of a appointment by cost centre manager not lower than a Senior manager and availability of a file',
        criterion: '1.1 Inspect the appointment letter and check its validity and whether training was provided.(32-1034: 3.5.14 and 8.5.3)',
        risk: 'possible non-compliance',
      },
      {
        stage: '1 Check the Validity /Training of a appointment by cost centre manager not lower than a Senior manager and availability of a file',
        criterion: '1.2 Are documents saved on the Eskom Electronic Document management system for Audit trail (EDMS)?.(32-1034: 8.2.2)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Identifying when it is permissible to use the LPO mechanism',
        criterion: '2.1 Is the purchase for non-complex goods or services (32-1034: 8.5.1)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Identifying when it is permissible to use the LPO mechanism',
        criterion: '2.2 Is the purchase for once-off goods or services (32-1034: 8.5.1)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Identifying when it is permissible to use the LPO mechanism',
        criterion: '2.3 Is the purchase for non-stock goods. (32-1034: 8.5.1)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Identifying when it is permissible to use the LPO mechanism',
        criterion: '2.4 Is the purchase for goods or services not included in any existing contracts with suppliers (32-1034: 8.5.1)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Identifying when it is permissible to use the LPO mechanism',
        criterion: '2.5 Does the LPO purchase exceed the R30k threshold (32-1034: 8.5.1)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Identifying when it is permissible to use the LPO mechanism',
        criterion: '2. 6 CPA should not apply. Is it applied on this LPO? (32-1034: 8.5.1)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Identifying when it is permissible to use the LPO mechanism',
        criterion: '2.7 Forex should not apply. Is it applied on this LPO? (32-1034: 8.5.1)',
        risk: 'possible non-compliance - possible FWE',
      },
      {
        stage: '3. Enquiry/RFQ',
        criterion: '3.1 Is PR or Written request available from an end-user? (32-1034: Appendix A: A1)',
        risk: 'non-conformance',
      },
      {
        stage: '3. Enquiry/RFQ',
        criterion: '3.2 Is there an Enquiry/RFQ?(32-1034: Appendix A: A3.1)',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Enquiry/RFQ',
        criterion: '3.3 Was the Hierarchy followed (32-1034: Appendix A:A2.)',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Enquiry/RFQ',
        criterion: '3.4 Were 3 suppliers selected from the CSD system. Proof of CSD report (32-1034: Appendix A A4.2)',
        risk: 'Depend, is 3 an Eskom requirement?',
      },
      {
        stage: '3. Enquiry/RFQ',
        criterion: '3.5 Proof of Procurement manager approval in cases where suppliers not identified via CSD/market research/analysis (32-1034: Appendix A: A4.4)',
        risk: 'non-conformance',
      },
      {
        stage: '3. Enquiry/RFQ',
        criterion: '3.6 Was the specific goals requested from SDL&I e.g sworn affidavit or BBBEE Certificate (32-1034: 8.5.1)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Evaluation',
        criterion: '4.1 Has the LPO not been awarded to highest-ranked tenderer based on SDL&I justification. (32-1034: Appendix A & PPR 2022)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Evaluation',
        criterion: '4.2 Is the justification of not awarding to the highest ranked tenderer included in the enquiry document (32-1034: Appendix A: A10.1)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Evaluation',
        criterion: '4.3 Inpect the Authorisation Form and Integrity Declaration Form, Declaration of Shareholding and Directorship, and SBD 4(Bidders Declaration of Interest) as part of LPO returnables (32-1034: Appendix A :A3.5)',
        risk: 'Depends - which doc is legislative . i.e SBD4',
      },
      {
        stage: '4. Evaluation',
        criterion: '4.4 Verification of the market-related prices - proof (32-1034: Appendix A : A6)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Evaluation',
        criterion: '4.5 Proof of tax compliance (32-1034: Appendix A : A7)',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Evaluation',
        criterion: '4.6 LPO reference to Eskom General Conditions of Purchase (32-1034: Appendix A : A8)',
        risk: 'non-conformance',
      },
      {
        stage: '4. Evaluation',
        criterion: '4.7 LPO Orders created using separate and individual catalogued and/or STG records that accurately describe the goods, works and services as the supplier has indicated on the quotation? (32-1034: Appendix A : A8)',
        risk: 'non-conformance',
      },
      {
        stage: '5. Approval',
        criterion: '5.1 Did the Cost centre owner confirm that the prices to be paid are within the price check prices and are market related? (32-1034: Appendix A:A10.3)',
        risk: 'non-conformance',
      },
      {
        stage: '5. Approval',
        criterion: '5.2 Is the order signed? (32-1034: Appendix A:A11)',
        risk: 'non-conformance',
      },
      {
        stage: 'No modifications will be allowed on LPO orders',
        criterion: '6.1 PO modification are not allowed within LPO. Has the LPO been modified? (32-1034:8.5.1)',
        risk: 'possible non-compliance',
      },
    ],
  },
  'Emergency': {
    name: 'Emergency',
    criteria: [
      {
        stage: '1. Assess the declaration of the emergency procurement route',
        criterion: '1.1 Approved Emergency Request Form by the relevant Eskom DE / GE / MD / GM ERI? (32-1034: 8.9.4 (b) (c))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the emergency procurement route',
        criterion: '1.2 Check if the detailed motivation aligns with the identified risk and criterion for use of Emergency Procurement route (32-1034: 8.9.4 (a))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the emergency procurement route',
        criterion: '1.3 Check if the actions needed to mitigate harm or to prevent the threat from materialising were provided? (32-1034: 8.9.4 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the emergency procurement route',
        criterion: '1.4 Was it confirmed if the emergency scope does not fall within the scope of an existing site / OU contract? (32-1034: 8.9.4 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the emergency procurement route',
        criterion: '1.5 Was it confirmed if the emergency in question will require several payments, in which case a contract must have been established? (32-1034: 8.9.4 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '2. Assess the legitimacy of the emergency situation',
        criterion: '2.1 Did the situation poses an immediate risk to health, life, property, or the environment ? (32-1034: Par 8.9.4 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess the legitimacy of the emergency situation',
        criterion: '2.2 Did the situation and identified risk called for urgent action? (32-1034: Par 8.9.4 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess the legitimacy of the emergency situation',
        criterion: '2.3 Was there insufficient time to invite competitive tenders? (32-1034: Par 8.9.4 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance with the identification of the supplier',
        criterion: '3.1 Check if there is a valid quotation from the identified supplier stating the estimated scope, value and time (32-1034: Par 8.9.4 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance with the identification of the supplier',
        criterion: '3.2 Was the quotation requested after the GE / MD / DE / GM ERI has approved or declared the emergency? (32-1034: 8.9.4 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance with the identification of the supplier',
        criterion: '3.3 Conflict of Interest (COI) by the end-user when the supplier was identified (32-1034: 8.9.4 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Assess compliance with the adjudication process',
        criterion: '4.1 Was the Emergency Submission Report supported and signed-off by the GE / MD / DE / GM ERI? (32-1034: 8.9.4 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '4. Assess compliance with the adjudication process',
        criterion: '4.2 Was the Emergency Submission Report submitted to the DAA for ratification at its next sitting or as soon as possible after the declaration of the emergency? (32-1034: 8.9.4 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '4. Assess compliance with the adjudication process',
        criterion: '4.3 Was the Emergency Submission Report approved by the DAA? (32-1034: 8.9.4 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '5.1 Was ZEM PR created on SAP? (32-1034: 8.9.4 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '5. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '5.2 Was the approval from the DAA and other supporting documentation attached on the PR? (32-1034: 8.9.4 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '5. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '5.3 Is all documentation uploaded on the Eskom Document Management System (EDMS)? (32-1034: 8.2.2)',
        risk: 'non-conformance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '6.1 Valid BBBEE certificate or sworn affidavit of the awarded supplier (32-1034: 10.2.1)',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '6.2 CSD Report of the awarded supplier (32-1034: 8.9.4 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '6.3 SBD4 bidder’s disclosure form of the awarded supplier and integrity pact (32-1034: 8.8.4 (k and 4.2.7))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '7.1 Is the order /contract aligned with the approval from the DAA? (32-1034: 8.9.4 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '7.2 Was the supplier tax compliant at order /contract placement? Check CSD report or SARS e-file screen shot (32-1034: 8.8.12 (p))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '7.3 Was the Emergency Procurement reported to NT and to the AGSA within a month after finalisation of the procurement via OCPO? (Procurement Instruction 09 of 2024 (3.26))',
        risk: 'possible non-compliance',
      },
    ],
  },
  'Urgent': {
    name: 'Urgent',
    criteria: [
      {
        stage: '1. Assess the declaration of the urgent procurement route',
        criterion: '1.1 Approved Urgent Procurement Request Form by the relevant GE/Corporate GM/Subsidiary CEO? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the urgent procurement route',
        criterion: '1.2 Check if the detailed motivation aligns with the conditions and circumstances for use of urgent procurement route (Procurment Instructtion 2 of 2025 (a))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the urgent procurement route',
        criterion: '1.3 Were the steps that will be taken in order to prevent future deviation from competitive tendering and to prevent future reliance on the urgent procurement process stated on the Urgent Procurement Request Form? (Procurment Instructtion 2 of 2025 (a))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the urgent procurement route',
        criterion: '1.4 Was the contract period provided on the Urgent Procurement Request Form and was it limited to a maximum period of twelve months? (Procurment Instructtion 2 of 2025 (a))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the urgent procurement route',
        criterion: '1.5 After evaluating the urgent situation did the Power Station Manager / GM provide actions needed to prevent the threat from materialising and supported by the Senior Procurement Manager? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '1. Assess the declaration of the urgent procurement route',
        criterion: '1.6 Did the Senior Procurement Manager confirmed that the urgent scope does not fall within the scope of an existing site / OU contract? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '2. Assess the legitimacy of the urgent situation',
        criterion: '2.1 Was early delivery of critical importance? (Procurment Instructtion 2 of 2025 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess the legitimacy of the urgent situation',
        criterion: '2.2 Was it impossible or impractical for Eskom to invite competitive bids? (Procurment Instructtion 2 of 2025 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess the legitimacy of the urgent situation',
        criterion: '2.3 Was it proven that the urgent situation is not due to improper/lack of planning? (Procurment Instructtion 2 of 2025 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess the legitimacy of the urgent situation',
        criterion: '2.4 Did the urgent situation meet any of the following circumstances: • Threats of interruptions in the supply of electricity to customers resulting in load shedding/load reduction and/or production loss; AND/OR • The threat of major consequential expense to Eskom; AND/ OR • The threat of serious damage to Eskom’s reputation. (Procurment Instructtion 2 of 2025 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance with the identification of the supplier',
        criterion: '3.1 Check if there is a valid quotation from the identified supplier stating the estimated scope, value and time (Procurment Instructtion 2 of 2025 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance with the identification of the supplier',
        criterion: '3.2 Was the quotation requested after the GE/Corporate GM/Subsidiary CEO has approved the Urgent Procurement Request Form? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '3. Assess compliance with the identification of the supplier',
        criterion: '3.3 Check if end-user, relevant GM, relevant Senior Manager Procurement and GE/Corporate GM/Subsidiary CEO have completed and signed a conflict-of-interest declaration (COI) when the potential supplier was recommended to the DAA (Procurment Instructtion 2 of 2025 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Assess compliance with the adjudication process',
        criterion: '4.1 Was the Ratification Report approved by the relevant DAA (Check if the DAA that approves the ratification is not the same as the Senior Manager Procurement who supported the request) ? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '4. Assess compliance with the adjudication process',
        criterion: '4.2 In case where a mandate to negotiate was sought from the relevant DAA, check the approved mandate to negotiate report, negotiation pack (agenda, signed negotiation minutes by both parties, signed attendance register by both parties) and approved feedback report by the relevant DAA (Procurment Instructtion 2 of 2025 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '5. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '5.1 Was the approval from the DAA and other supporting documentation attached on the PR? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '5. Assess compliance with systems (SAP & EDMS) requirements',
        criterion: '5.2 Is all documentation uploaded on the Eskom Document Management System (EDMS)? (32-1034: 8.2.2)',
        risk: 'non-conformance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '6.1 Valid BBBEE certificate or sworn affidavit of the awarded supplier (32-1034: 10.2.1)',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '6.2 CSD Report of the awarded supplier (32-1034: 8.9.5 (b))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '6.3 SBD4 bidder’s disclosure form of the awarded supplier (32-1034: 8.8.4 (k))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '7.1 Is the order/contract aligned with the approval from the DAA? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '7.2 Was the supplier tax compliant at order/contract placement? Check CSD report or SARS e-file screen shot (32-1034: 8.8.12 (p))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '7.3 Was the Urgent Procurement reported to NT and to the AGSA within a month after finalisation of the procurement via OCPO? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '6. Assess compliance with the statutory requirements',
        criterion: '7.4 In case where the order/contract was modified: Is there a written support from the Divisional GE/DE/GM ERI? Was the modification approved by the relevant DAA? Was the order/contract duration still kept within the duration of 12 months? (Procurment Instructtion 2 of 2025 (c))',
        risk: 'non-conformance',
      },
    ],
  },
  'Sole Source': {
    name: 'Sole Source',
    criteria: [
      {
        stage: '1.Identifying when it is permissible to use the Sole Source mechanism',
        criterion: '1.1 Check the fully signed and approved SSJF (Note: Gx approval must include Steering Committee and relevant GE) (32-1034: 8.9.1)',
        risk: 'non-conformance',
      },
      {
        stage: '1.Identifying when it is permissible to use the Sole Source mechanism',
        criterion: '1.2 Did the identified supplier meet the criteria of using a sole source route? (True sole source / OEM / Incompatible Material) (32-1034: 8.9.1 (a))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '2.1 Was the market research conducted? It can be done using one or more of the following: (32-1034: 8.9.1 (a)) 1. Conduct research on recent contracts established for the same scope; 2. Provide evidence based on recent previous open enquiries issued to the market that are not older than 6 months; 3. Together with the SDL&I or Business Intelligence Analysts, conduct desktop market research; 4. Initiate formal testing of the market through non-competitive enquiries such as an EOI or RFI issued through the relevant tender office.',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '2.2 Check the letter from the OEM / IP holder and verification of its content by the Procurement Practitioner (32-1034: 8.9.1 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.1 Check the approval of the Commercial Strategy and issuing of the Enquiry to the prospective supplier by the relevant DAA (32-1034: 8.9.1 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.2 Check the appointment of the CFT & DoI (Good governance)',
        risk: 'Depends, i.e DoI will result in possible non-compliance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.3 Check the evaluation process of the prospective supplier’s offer (all applicable evaluation disciplines as per the approved strategy) (32-1034: 8.9.1 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.4 Check the adjudication process by the relevant DAA (Evaluation / Mandate & Feedback) (32-1034: 8.9.1 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.5 If negotiations were held, check the evaluation pack (Agenda, signed minutes, DoI & NDA by both parties) (32-1034: 8.9.1 (c))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.6 Is the relevant Procurement Manager notified when a sole source vendor is engaged across multiple sites for the same scope, to support future Regional, Divisional, or National contract arrangements? (32-1034: 8.9.1 (c))',
        risk: 'non-conformance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.7 Assess compliance with the statutory requirements (BBBEE certificate/Sworn Affidavit, SBD4, CSD report & Tax status on contract creation) (32-1034: 10.2.1 & 32-1034 8.8.12)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.8 Check if the contract is signed by both parties (32-1034: 8.8.14 (b))',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing whether there is competition in the market',
        criterion: '3.9 Was the Sole Source transaction reported to NT and to the AGSA within a month after finalisation of the procurement? (Procurement Instruction 09 of 2024 (3.26))',
        risk: 'possible non-compliance',
      },
    ],
  },
  'Single Source': {
    name: 'Single Source',
    criteria: [
      {
        stage: '1. Identifying when it is permissible to use the informal tendering mechanism',
        criterion: '1.1 Did the identified supplier meet the criteria of using a single source route as indicated in the SSJF? – Source of evidence will be the approved SSJF and the motivation (32-1034: 8.9.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '1. Identifying when it is permissible to use the informal tendering mechanism',
        criterion: '1.2 Check if the market analaysis was conducetd to determine the need of using a Single Source (32-1034: 8.9.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '1. Identifying when it is permissible to use the informal tendering mechanism',
        criterion: '1.3 Determine whether the process of identifying the preferred supplier was both transparent and equitable (32-1034: 8.9.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '1. Identifying when it is permissible to use the informal tendering mechanism',
        criterion: '1.4 Check the formal cost / benefit analysis conducted to establish whether it is more cost-effective to continue with the on-site, established supplier, or whether it would be beneficial to request competitive proposals.(32-1034: 8.9.2)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Assess compliance with the process followed under Single Source',
        criterion: '2.1 Check if there is an approved SSJF by the Steering Committee (Gx only) and relevant GE (Gx Sole and Single Source Works Instruction - 3.5.8)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Assess compliance with the process followed under Single Source',
        criterion: '2.2 Check the approval of the Commercial Strategy (32-1034: 8.9.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance with the process followed under Single Source',
        criterion: '2.3 Check the appointment of the CFT & DoI (Good governance)',
        risk: 'Depends, i.e DoI will result in possible non-compliance',
      },
      {
        stage: '2. Assess compliance with the process followed under Single Source',
        criterion: '2.4 Check the evaluation process of the prospective supplier’s offer (all applicable evaluation disciplines as per the approved strategy) (32-1034: 8.9.2)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Assess compliance with the process followed under Single Source',
        criterion: '2.5 Check the adjudication process by the relevant DAA (Evaluation / Mandate & Feedback) (32-1034: 8.9.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance with the process followed under Single Source',
        criterion: '2.6 If negotiations were held, check the evaluation pack (Agenda, signed minutes, DoI & NDA by both parties (32-1034: 8.9.2)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance with the process followed under Single Source',
        criterion: '2.7 Assess compliance with the statutory requirements (BBBEE certificate/Sworn Affidavit, SBD4, CSD report & Tax status on contract creation) and check signed contract by both parties (32-1034: 10.2.1 & 32-1034: 8.8.12)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Assess compliance with the process followed under Single Source',
        criterion: '2.8 Was the Single Source transaction reported to NT and to the AGSA within a month after finalisation of the procurement? (Procurement Instruction 09 of 2024 (3.26))',
        risk: 'possible non-compliance',
      },
    ],
  },
  'Expansions - Modifications': {
    name: 'Expansions - Modifications',
    criteria: [
      {
        stage: '1. Identifying when it is permissible to request a modification',
        criterion: '1.1 Check if the modification met the criteria of modifying the contract: 1. Increase in the approved contract duration; 2. Changes to the conditions of contract; 3. Changes to the contracting parties; 4. Changes to specification, design, or scope; 5. Increase in the quantities of goods, works and services; 6. Changes in the country of origin / manufacture of assets or goods (32-1034: 8.10)',
        risk: 'non-conformance',
      },
      {
        stage: '1. Identifying when it is permissible to request a modification',
        criterion: '1.2 Check if the request for modification that is above the NT Modification Shreshold (15%/R15m or 20%/R20M including vat) was reported to NT, and was supported in writting by the relevant GM prio being approved by the relevant DAA. If modification is below these NT threshhold was supported by the relevant PSCM Senior Manager prio being approved by the relevant DAA (32-1034: 8.10 & Procurement Instruction 05 of 2024 )',
        risk: 'possible non-compliance',
      },
      {
        stage: '1. Identifying when it is permissible to request a modification',
        criterion: '1.3 Check if there is written confirmation that the envisaged expenditure has been budgeted for. (32-1034: 8.10)',
        risk: 'possible non-compliance',
      },
      {
        stage: '1. Identifying when it is permissible to request a modification',
        criterion: '1.4 Check which form of procurement mechanism is being modified (Note: modifications may not be sought in respect of LPOs, low-value informal tendering, or Emergency Procurement) (32-1034: 8.10)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Establishing the modification process due diligence',
        criterion: '2.1 Check if the modification request was requested via Procurement Department when there was still sufficient time to obtain approval for the modification, which must be before the SAP expiry date of the contract. (32-1034: 8.10)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Establishing the modification process due diligence',
        criterion: '2.2 Check if it was confirmed that the prices quoted for modification were market related.(32-1034: 8.10)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing the modification process due diligence',
        criterion: '2.3 Check if the SDL&I targets / commitments were adjusted in order to benefit from increases in the contract value. (32-1034: 8.10)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Establishing the modification process due diligence',
        criterion: '2.4 Check if the risk assessment clearly indicated the reason for the modification or increase to the contingency time / value. (32-1034: 8.10)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Establishing the modification process due diligence',
        criterion: '2.5 Check if the request for modification was approved by the relevant DAA (32-1034: 8.10)',
        risk: 'possible non-compliance',
      },
      {
        stage: '2. Establishing the modification process due diligence',
        criterion: '2.6 Check if the authorised supplier’s representative and authorised Eskom representative did sign the amendment / modification to the contract (32-1034: 8.10)',
        risk: 'non-conformance',
      },
      {
        stage: '2. Establishing the modification process due diligence',
        criterion: '2.7 Check if the Procurement Practitioner updated the electronic purchasing system (SAP) with the amended contract values and/or time, and/or the amended contingency value and time and filed the original amendment with the rest of the contract documents for audit purposes (32-1034: 8.10)',
        risk: 'non-conformance',
      },
    ],
  },
};
